"use strict";
import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useCallback, useRef } from "react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";

 
const CustomLoadingOverlay = (props) => {
  return (
    <div
      className="ag-overlay-loading-center"
      style={{ height: '9%' }}
    >
      {props.loadingMessage}
    </div>
  );
};
const CustomNoRowsOverlay = (props) => {
  return (
    <div
      className="ag-overlay-loading-center"
      style={{ height: '9%' }}
    >
      {props.noRowsMessageFunc()}
    </div>
  );
};

const AgGrid = ({
  rowData,
  columnDefs,
  sortable,
  filter,
  resizable,
  onGridReady,
  rowSelection,
  rowMultiSelectWithClick,
  height,
  loadingOverlay
}) => {
  const gridRef = useRef();
  const containerStyle = useMemo(
    () => ({ width: "100%", height: height || "100%" }),
    []
  );
  const gridStyle = useMemo(
    () => ({ height: height || "100%", width: "100%" }),
    []
  );
  const defaultColDef = useMemo(
    () => ({
      sortable: sortable,
      filter: filter,
      resizable: resizable,
      animateRows: true,
    }),
    []
  );
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const onSelectionChanged = () => {
    const selectedData = gridRef.current.api.getSelectedRows();
    console.log("Selection Changed", selectedData);
  };

  const loadingOverlayComponent = useMemo(() => {
    return CustomLoadingOverlay;
  }, []);
  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: loadingOverlay,
    };
  }, []);
  const noRowsOverlayComponent = useMemo(() => {
    return CustomNoRowsOverlay;
  }, []);
  const noRowsOverlayComponentParams = useMemo(() => {
    return {
      noRowsMessageFunc: () => 'Sorry - no information found.',
    };
  }, []);

  const onBtPivotMode = useCallback(() => {
    gridRef.current.columnApi.setPivotMode(true);
    gridRef.current.columnApi.applyColumnState({
      //   state: [
      //     { colId: 'country', rowGroup: true },
      //     { colId: 'year', rowGroup: true },
      //   ],
      defaultState: {
        pivot: false,
        rowGroup: false,
      },
    });
  }, []);

  return (
    <div style={containerStyle}>
      <div className="ag-theme-balham" style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          alwaysShowHorizontalScroll={false}
          alwaysShowVerticalScroll={false}
          sideBar={"columns"}
          onFirstDataRendered={onFirstDataRendered}
          rowSelection={rowSelection}
          rowMultiSelectWithClick={rowMultiSelectWithClick}
          onSelectionChanged={onSelectionChanged}
          loadingOverlayComponent={loadingOverlayComponent}
          loadingOverlayComponentParams={loadingOverlayComponentParams}
          // noRowsOverlayComponent={noRowsOverlayComponent}
          // noRowsOverlayComponentParams={noRowsOverlayComponentParams}
        />
      </div>
    </div>
  );
};

export default AgGrid;
